import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserSession } from "../../actions/auth";
import { getContact } from "../navigation/Contact";
// import geotrust from "../../images/geotrustssl.png";
import TopNavigation from "../navigation/TopNavigation";

class AppRedirectPage extends Component {
  componentDidMount() {
    const sessionId = this.getSessionId();
    if (sessionId === null) this.props.history.push(`/login`);
    this.props.getUserSession(sessionId).then(() => {
      if (localStorage.appToken) {
        localStorage.removeItem("loginFailed");
        // window.location.href = `../securityquestions`;
        window.location.href = `../securitytoken`;
        this.setState({ loginError: "" });
      }
    });
  }

  getSessionId = () => {
    const pathTokens = decodeURI(this.props.history.location.pathname).split(
      "/"
    );
    if (pathTokens.length !== 3) return null;
    return pathTokens[2];
  };

  render() {
    return (
      <div>
        <TopNavigation />
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="container-fluid padding-top-10">
            <div className="row security-box">
              <div className="col-lg-1" />
              <div className="col-lg-6 col-md-6 col-sm-6 login-box-left">
                <div className="security-heading">
                  <strong>Loading...</strong>
                </div>
                <div className="padding-top-20" />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2" />
              <div className="col-lg-3 col-md-3 col-sm-3 login-box-right padding-top-5">
                <div className="padding-top-35">{getContact()}</div>
                <div className="padding-top-20" />

                <div className="col-lg-2 col-md-2 col-sm-2" />

                {/* <div className="col-lg-4 col-sm-4">
                  <a
                    href="https://sealsplash.geotrust.com/splash?&amp;dn=app.locateplus.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    alt="Geo Trust SSL certificate for LocatePLUS which open in a new tab"
                  >
                    <img
                      name="Geo Trust Secured"
                      src={geotrust}
                      alt="Click to Verify - This site has chosen a GeoTrust SSL Certificate to improve Web site security"
                    />
                  </a>
                </div> */}

                <div className="padding-top-20" />

                <div className="hide-on-smallscreen">
                  <div className="padding-top-20" />

                  <div className="padding-top-20" />

                  <div className="padding-top-20" />
                </div>

                {/* <div
                  className="col-lg-4 col-sm-4 hide-on-smallscreen"
                  style={{ marginBottom: "20px" }}
                >
                  <iframe
                    src="https://www.whatismybrowser.com/feature/iframe?size=small&bgcolor=FFFFFF&font=Calibri&color=4f4f4f"
                    title="Browser check with what is my browser"
                    width="210"
                    height="105px"
                    className={"table-no-border"}
                  />
                </div> */}

                <div className="padding-top-20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  getUserSession,
})(AppRedirectPage);



// WEBPACK FOOTER //
// ./src/components/pages/AppRedirect.js